'use strict';
module.exports = function getValueForKeyArray(params) {
	if (!params) {
		throw new Error('invalid-args');
	}

	const {target, keyArray} = params,
		validArgs = params && target && keyArray && Array.isArray(keyArray) && keyArray.length && keyArray[0],
		property = validArgs && keyArray[0],
		remainingKeyArray = validArgs && keyArray.slice(1),
		propertyValue = validArgs && target[property],
		isArrayIndex = validArgs && Array.isArray(target) && Number.isInteger(property);

	if (!validArgs) {
		throw new Error('invalid-args');
	}

	if (!isArrayIndex && !Object.prototype.hasOwnProperty.call(target, property)) {
		return false;
	}
	if (remainingKeyArray.length && propertyValue) {
		return getValueForKeyArray({target: propertyValue, keyArray: remainingKeyArray});
	}
	return propertyValue;

};
